import http, { apiErrorMessage, descargarExcelPorToken } from '../../http';

const vRutaDashboard = 'dashboard/';

export const getFechaLarga = () =>{
    return (dispatch,getState) =>{
        http.get(vRutaDashboard + 'fecha-actual')
            .then(function(response){
                // Envelope v1: {data:{Fecha}}
                dispatch({
                    type: "DASHBOARD_FECHA_SUCCESS", payload:{
                        data: response.data.data
                    }
                })
            }).catch(function (error) {
                dispatch({ type: 'DASHBOARD_FECHA_ERROR', payload: { error: apiErrorMessage(error) } });
            }).finally(function () {
                //dispatch({ type: 'HIDE_LOADING' });
            }
        );
    }
}

export const getListForTable = (sucursal) =>{
    return (dispatch, getState) => {
        http.get(vRutaDashboard + 'resumen-repartos', { params: { sucursal } })
            .then(function (response){
                // Envelope v1: {data:{Tabla,Repartos}}
                dispatch({
                    type: "DASHBOARD_SUCCESS", payload: {
                        data: response.data.data,
                    }
                });
            })
            .catch(function (error) {
                dispatch({ type: 'DASHBOARD_ERROR', payload: { error: apiErrorMessage(error) } });
            })
            .finally(function () {
                //dispatch({ type: 'HIDE_LOADING' });
            }
        );
    }
}

export const getIndicadores = (sucursal) => {
    return (dispatch, getState) => {
        http.get(vRutaDashboard + 'efectividad-ead', { params: { sucursal } })
            .then(function (response){
                // Envelope v1: {data:{ead,rad}}
                dispatch({
                    type: "DASHBOARD_INDICADORES_SUCCESS", payload: {
                        data: response.data.data,
                    }
                });
            })
            .catch(function (error) {
                dispatch({ type: 'DASHBOARD_ERROR', payload: { error: apiErrorMessage(error) } });
            })
            .finally(function () {
                //dispatch({ type: 'HIDE_LOADING' });
            }
        );
    }
}

// Excel de entregas/devoluciones diarias por unidad (ultimos 30 dias): flujo de 2 pasos
// autenticado en una sola accion — POST genera el .xlsx y devuelve {nombreexcel,fileToken};
// luego se descarga por token (blob + <a download>). sucursal 1 (matriz) => todas.
// Devuelve la promesa para que la vista controle el estado de "descargando".
export const descargarEntregasDiarias = (sucursal) => {
    return (dispatch) => {
        return http.post(vRutaDashboard + 'entregas-diarias/excel', { sucursal })
            .then(function (response) {
                // Envelope v1: {data:{nombreexcel,fileToken}}
                const excel = response.data.data;
                return descargarExcelPorToken('dashboard/entregas-diarias', excel.fileToken, excel.nombreexcel);
            })
            .catch(function (error) {
                dispatch({ type: 'DASHBOARD_ENTREGAS_EXCEL_ERROR', payload: { error: apiErrorMessage(error) } });
                return Promise.reject(error);
            });
    }
}

export const LimpiarEntregasDiariasError = () => {
    return (dispatch) => {
        dispatch({ type: 'DASHBOARD_ENTREGAS_EXCEL_LIMPIAR' });
    }
}
